import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _get from "lodash/get";
import _merge from "lodash/merge";

var _createReducer;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createReducer } from 'redux-act';
import { authenticateWithGoogle, authenticateWithApple, createTUCustomer, signin, register, setTUAuthentication, updateProfileSuccess, updateTrackingParams, saveRegisterImpression } from "../actions";
var defaultState = {
  trk: {}
};
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, updateTrackingParams, function (state, _ref) {
  var trk = _ref.trk,
      amplitudeOnlyTrk = _ref.amplitudeOnlyTrk,
      appName = _ref.appName;
  return _merge({}, state, {
    trk: trk,
    amplitudeOnlyTrk: amplitudeOnlyTrk,
    appName: appName
  });
}), _defineProperty(_createReducer, authenticateWithGoogle.success, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    authTypeUsed: 'google'
  });
}), _defineProperty(_createReducer, authenticateWithApple.success, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    authTypeUsed: 'apple'
  });
}), _defineProperty(_createReducer, createTUCustomer.success, function (state, payload, meta) {
  return _objectSpread(_objectSpread({}, state), {}, {
    tuCustomerCreated: true,
    tuVerificationType: meta.isFullSSN ? 'FULL_VERIFICATION' : 'BASIC_VERIFICATION'
  });
}), _defineProperty(_createReducer, signin.success, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    authTypeUsed: 'nerdwallet'
  });
}), _defineProperty(_createReducer, register.success, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    authTypeUsed: 'nerdwallet'
  });
}), _defineProperty(_createReducer, setTUAuthentication.success, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    authTypeUsed: 'nerdwallet'
  });
}), _defineProperty(_createReducer, setTUAuthentication.success, function (state, payload) {
  var hasQuestions = !!_get(payload, 'data.questions');
  var success = hasQuestions ? 'loop' : 'true';
  return _objectSpread(_objectSpread({}, state), {}, {
    lastTUAuthenticateResult: success
  });
}), _defineProperty(_createReducer, setTUAuthentication.fail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    lastTUAuthenticateResult: 'false'
  });
}), _defineProperty(_createReducer, updateProfileSuccess, function (state, payload, meta) {
  if (meta.actionName === 'updateCreditScorePurpose') {
    return _objectSpread(_objectSpread({}, state), {}, {
      creditPurpose: meta.purpose
    });
  }

  return state;
}), _defineProperty(_createReducer, saveRegisterImpression, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    registerImpressionId: payload.impressionId
  });
}), _createReducer), defaultState);